import React, { memo } from "react";
import PropTypes from "prop-types";

import PersonalDetails from "./PersonalDetails";
import TechnicalDetails from "./TechnicalDetails";

const GeneralDetails = memo(({ customer }) => {
	return (
		<div className="row">
			<div className="col-xs-6">
				<PersonalDetails customer={customer} />
			</div>
			<div className="col-xs-6">
				<TechnicalDetails customer={customer} />
			</div>
		</div>
	);
});
GeneralDetails.displayName = `GeneralDetails`;
GeneralDetails.propTypes = {
	customer: PropTypes.object.isRequired
};

export default GeneralDetails;
